export class BraintreeBgTranslationConfig {
    translations = {
        payingWith: 'Плащане чрез {{paymentSource}}',
        chooseAnotherWayToPay: 'Изберете друг начин на плащане',
        chooseAWayToPay: 'Изберете начин на плащане',
        otherWaysToPay: 'Други начини на плащане',
        edit: 'Редактирай',
        doneEditing: 'Запази',
        editPaymentMethods: 'Редактирай методите на плащане',
        CreditCardDeleteConfirmationMessage: 'Изтрий {{secondaryIdentifier}} картата завършваща на {{identifier}}?',
        PayPalAccountDeleteConfirmationMessage: 'Изтрий Paypal профила {{identifier}}?',
        genericDeleteConfirmationMessage: 'Наистина ли искате да изтриете този начин на плащане?',
        deleteCancelButton: 'Откажи',
        deleteConfirmationButton: 'Изтрий',
        // Errors
        fieldEmptyForCvv: 'Моля, попълнете CVV кода отзад на картата.',
        fieldEmptyForExpirationDate: 'Моля, въведете дата на изтичане на картата',
        fieldEmptyForCardholderName: 'Моля, въведете името изписано върху картата.',
        fieldEmptyForNumber: 'Моля, попълнете номера на картата.',
        fieldEmptyForPostalCode: 'Моля, въведете пощенски код.',
        fieldInvalidForCvv: 'Кода за сигурност е невалиден.',
        fieldInvalidForExpirationDate: 'Датата на изтичане е невалидна.',
        fieldInvalidForNumber: 'Номера на картата е невалиден.',
        fieldInvalidForPostalCode: 'Пощенския код е невалиден.',
        fieldTooLongForCardholderName: 'Името изписано върху картата трябва да бъде по малко от 256 символа.',
        genericError: 'Нещо се обърка.',
        hostedFieldsTokenizationFailOnDuplicateError: 'Тази кредитна карта вече съществува като запазен начин на плащане.',
        hostedFieldsFailedTokenizationError: 'Моля, проверете информацията си и опитайте отново.',
        hostedFieldsTokenizationCvvVerificationFailedError: 'Проверката на кредитната карта не бе успешна. Моля, проверете информацията си и опитайте отново.',
        hostedFieldsTokenizationNetworkErrorError: 'Мрежова грешка. Моля, опитайте отново.',
        hostedFieldsFieldsInvalidError: 'Моля, проверете информацията си и опитайте отново.',
        paypalButtonMustBeUsed: 'Използвайте бутона PayPal, за да продължите с плащането си.',
        paypalAccountTokenizationFailedError: 'Нещо се обърка при добавянето на акаунта в PayPal. Моля, опитайте отново.',
        paypalFlowFailedError: 'Нещо се обърка при свързването с PayPal. Моля, опитайте отново.',
        paypalTokenizationRequestActiveError: 'Разрешението за плащане чрез PayPal вече е в ход.',
        applePayTokenizationError: 'Възникна мрежова грешка при обработката на плащането с Apple Pay. Моля, опитайте отново.',
        applePayActiveCardError: 'Добавете поддържана карта към вашия Apple Pay портфейл.',
        vaultManagerPaymentMethodDeletionError: 'Не можете да изтриете начина на плащане, опитайте отново.',
        venmoCanceledError: 'Нещо се обърка. Уверете се, че имате най-новата версия на приложението Venmo, инсталирано на вашето устройство, и вашият браузър поддържа преминаване към Venmo.',
        venmoAppFailedError: 'Приложението Venmo не можа да бъде намерено на вашето устройство.',
        unsupportedCardTypeError: 'Този тип карти не се поддържа. Моля, опитайте друга карта.',
        // Card form
        cardholderNameLabel: 'Име на картодържателя',
        cardNumberLabel: 'Номер на карта',
        cvvLabel: 'CVV',
        cvvThreeDigitLabelSubheading: '(3 цифри)',
        cvvFourDigitLabelSubheading: '(4 цифри)',
        expirationDateLabel: 'Дата на изтичане',
        expirationDateLabelSubheading: '(MM/YY)',
        cardholderNamePlaceholder: 'Име на картодържателя',
        expirationDatePlaceholder: 'MM/YY',
        postalCodeLabel: 'Пощенски код',
        saveCardLabel: 'Запази картата',
        payWithCard: 'Плати чрез карта',
        // Payment Method descriptions
        endingIn: 'Завършваща на {{lastFourCardDigits}}',
        Card: 'Карта',
        PayPal: 'PayPal',
        'PayPal Credit': 'PayPal Кредит',
        'Apple Pay': 'Apple Pay',
        'Google Pay': 'Google Pay',
        'Venmo': 'Venmo',
        'American Express': 'American Express',
        Discover: 'Discover',
        'Diners Club': 'Diners Club',
        MasterCard: 'Mastercard',
        Visa: 'Visa',
        JCB: 'JCB',
        Maestro: 'Maestro',
        UnionPay: 'UnionPay'
    };
}
